import React, { useRef, useState } from "react";
import { forgetPassword } from "../../../services/AuthService";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { APP_URL } from "../../../shared/constants";
import useFindMenuID from "../../../hooks/useFindSlug";
import useReducerHook from "../../../hooks/useReducerHook";
import useNavigateMenuId from "../../../hooks/useMenuId";
import { toast } from "react-toastify";
import ReCAPTCHA from "react-google-recaptcha";
import { SECRET_KEY } from "../../../shared/baseUrl";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { validateEmail } from "../../../hooks/CustomValidations";

const ForgotPassword = () => {
  const settingsData = useSelector((state) => state?.settingData?.settingDatas);
  const { pageMenus } = useReducerHook();
  const loginPage = useFindMenuID(pageMenus?.menuData, "login");
  const { navigatePageId } = useNavigateMenuId();
  const recaptchaRef = useRef(null);
  const [apiError, setApiError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const loginLogo = settingsData.find(
    (setting) => setting.key_name === "LOGIN_PAGE_IMG"
  );
  const loginPageImg = loginLogo?.key_value
    ? APP_URL + loginLogo.key_value
    : "";

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .required("Email is required")
      .test(
        "custom-email-validation",
        "Invalid email", 
        (value, ctx) => {
          const error = validateEmail(value);
          if (error) {
            return ctx.createError({ message: error });
          }
          return true; 
        }
      ),
    captcha: Yup.string().required("Captcha verification is required"),
  });

  const initialValues = {
    email: "",
    captcha: "",
  };

  const handleSubmit = async (values, { resetForm, setSubmitting }) => {
    setApiError("");
    setIsLoading(true);
    try {
      const response = await forgetPassword(values);
      if (response.status_code === 200) {
        toast.success("Temporary password has been sent to your email");
        setTimeout(() => {
          resetForm();
          recaptchaRef.current.reset();
          navigatePageId(loginPage);
        }, 3000);
      }
    } catch (error) {
    console.log(error,"error");
    
      setApiError(error?.response?.data?.data?.error || "Something went wrong");
      recaptchaRef.current.reset();
    } finally {
      setSubmitting(false);
      setIsLoading(false);
    }
  };

  return (
    <section className="login_section">
      <div className="container-fluid">
        <div className="login-container row justify-content-center">
          <div className="login-form col-md-5 col-12">
            <div className="col-8 m-auto mt-4">
              {isLoading && (
                <div style={{ fontSize: "20px" }}>
                  Email Sending Please Wait...
                </div>
              )}
              <p style={{ fontSize: "20px", textAlign: "center" }}>
                <b style={{ fontSize: "25px", color: "#505050" }}>
                  Forgot Password
                </b>
              </p>
              <p style={{ fontSize: "15px", paddingTop: "20px" }}>
                Lost your password? Please enter your email address. You will
                receive a link to create a new password via email.
              </p>
              {apiError && (
                <div style={{ color: "red", fontWeight: "bold" }}>
                  {apiError}
                </div>
              )}

              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                {({ setFieldValue }) => (
                  <Form>
                    <div className="form-group mb-2">
                      <Field
                        type="text"
                        name="email"
                        placeholder="Enter Your Email"
                        className="form-control"
                      />
                      <ErrorMessage
                        name="email"
                        component="div"
                        className="text-danger"
                      />
                    </div>

                    <div className="form-group mb-3">
                      <ReCAPTCHA
                        sitekey={SECRET_KEY}
                        ref={recaptchaRef}
                        onChange={(value) => {
                          setFieldValue("captcha", value);
                        }}
                      />
                      <ErrorMessage
                        name="captcha"
                        component="div"
                        className="text-danger mt-1"
                      />
                    </div>

                    <button
                      type="submit"
                      id="sendpasswordlink"
                      className="sendpasswordlink btn btn-dark btn-block btn-rounded mb-4"
                    >
                      Send Password Reset Link
                    </button>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ForgotPassword;
